export type Category = { slug: string; name: string; icon: string };

export const categories: Category[] = [
  { slug: "evler", name: "Evlər", icon: "🏠" },
  { slug: "menziller", name: "Mənzillər", icon: "🏢" },
  { slug: "baglar", name: "Bağlar", icon: "🌳" },
  { slug: "torpaq", name: "Torpaq", icon: "🏞️" },
  { slug: "ofisler", name: "Ofislər", icon: "🏢" },
  { slug: "otel", name: "Otel", icon: "🏨" },
  { slug: "obyektler", name: "Obyektlər", icon: "🏬" },
  { slug: "masinlar", name: "Maşınlar", icon: "🚗" },
  { slug: "motosikletler", name: "Motosikletlər", icon: "🏍" },
  { slug: "iki-tekerli-neqliyyat", name: "Skuter, motosiklet və digər iki təkərli nəqliyyat", icon: "🛵" },
  { slug: "telefonlar", name: "Telefonlar", icon: "📱" },
  { slug: "kompyuter-texnika", name: "Kompüter və Texnika", icon: "🖥" },
  { slug: "elektronika", name: "Elektronika", icon: "💻" },
  { slug: "meiset-esyalari", name: "Məişət Əşyaları", icon: "🛋" },
  { slug: "meiset-texnikasi", name: "Məişət texnikası", icon: "🔌" },
  { slug: "mebel", name: "Mebel", icon: "🪑" },
  { slug: "geyim", name: "Geyim", icon: "👕" },
  { slug: "ayaqqabi", name: "Ayaqqabı", icon: "👟" },
  { slug: "aksesuar", name: "Aksesuar", icon: "👜" },
  { slug: "kosmetika", name: "Kosmetika", icon: "💄" },
  { slug: "saatlar", name: "Saatlar", icon: "⌚" },
  { slug: "guzguler", name: "Güzgülər", icon: "🪞" },
  { slug: "dus-kabinleri", name: "Duş kabinləri", icon: "🚿" },

  { slug: "qizil-zinet", name: "Qızıl-zinət", icon: "💍" },
  { slug: "usaq-alemi", name: "Uşaq Aləmi", icon: "👶" },
  { slug: "heyvanlar", name: "Heyvanlar", icon: "🐶" },
  { slug: "idman-eylence", name: "İdman və Əyləncə", icon: "🏆" },
  { slug: "bag-bagciliq", name: "Bağ və Bağçılıq", icon: "🌱" },
  { slug: "tikinti-temir", name: "Tikinti və Təmir", icon: "🧱" },
  { slug: "sexsi-esyalar", name: "Şəxsi əşyalar", icon: "🎒" },
  { slug: "kitab-tehsil", name: "Kitab və Təhsil", icon: "📚" },
  { slug: "hobbi-kolleksiya", name: "Hobbi və Kolleksiya", icon: "🎨" },
  { slug: "pulsuz", name: "Pulsuz", icon: "🎁" },
  { slug: "xidmetler", name: "Xidmətlər", icon: "🔧" },
  { slug: "masaj", name: "Masaj xidmətləri", icon: "💆" },
  { slug: "kosmetoloq", name: "Kosmetoloq", icon: "💅" },
  { slug: "reklam", name: "Reklam", icon: "📢" },
  { slug: "is-elanlari", name: "İş Elanları", icon: "💼" },
  { slug: "kurslar", name: "Kurslar", icon: "🎓" },
  { slug: "sirniyyatlar", name: "Şirniyyatlar", icon: "🍰" },
];

export const cities: string[] = [
  "Bakı",
  "Sumqayıt",
  "Gəncə",
  "Xırdalan",
  "Abşeron",
  "Şamaxı",
  "Şəki",
  "Quba",
  "Qusar",
  "Lənkəran",
  "Mingəçevir",
  "Şirvan",
  "Yevlax",
  "Naxçıvan",
  "Bərdə",
  "Ağdam",
  "Sabirabad",
  "Masallı",
  "Zaqatala",
  "Qəbələ",
  "Ağcabədi",
  "Ağdaş",
  "Ağstafa",
  "Ağsu",
  "Astara",
  "Babək",
  "Balakən",
  "Beyləqan",
  "Biləsuvar",
  "Cəlilabad",
  "Culfa",
  "Daşkəsən",
  "Füzuli",
  "Gədəbəy",
  "Goranboy",
  "Göyçay",
  "Göygöl",
  "Hacıqabul",
  "İmişli",
  "İsmayıllı",
  "Kürdəmir",
  "Laçın",
  "Lerik",
  "Neftçala",
  "Oğuz",
  "Ordubad",
  "Qax",
  "Qazax",
  "Qobustan",
  "Saatlı",
  "Salyan",
  "Samux",
  "Siyəzən",
  "Şabran",
  "Şəmkir",
  "Şuşa",
  "Tərtər",
  "Tovuz",
  "Ucar",
  "Xaçmaz",
  "Xankəndi",
  "Yardımlı",
  "Zəngilan",
  "Zərdab",
];

export const popularCities = [
  { name: "Bakı", count: 18420 },
  { name: "Sumqayıt", count: 4310 },
  { name: "Gəncə", count: 3890 },
  { name: "Xırdalan", count: 2140 },
  { name: "Şəki", count: 1120 },
  { name: "Lənkəran", count: 980 },
  { name: "Quba", count: 860 },
  { name: "Naxçıvan", count: 740 },
];

export type Ad = {
  id: string;
  title: string;
  description: string;
  price: number;
  negotiable: boolean;
  category: string;
  city: string;
  phone: string;
  whatsapp: string;
  seller: string;
  sellerSince: string;
  createdAt: string;
  views: number;
  badge: "vip" | "premium" | "none";
  featured: boolean;
  images: string[];
  status: "active" | "pending" | "rejected" | "sold";
  ownerId?: string;
  badgePrice?: number;
  badgeExpiresAt?: string | null;
  specs?: Record<string, string>;
  /** Elan mağazaya aiddirsə true — video yalnız bu halda göstərilir. */
  isStore?: boolean;
  /** Admin tərəfindən əlavə edilmiş VIP göstəricisi. */
  adminVip?: boolean;
  /** Admin tərəfindən əlavə edilmiş Premium göstəricisi. */
  adminPremium?: boolean;
  /** Mağaza elanı üçün video faylının linki. */
  videoUrl?: string;
};

const seedTitles: Array<[string, string, number]> = [
  ["Yeni təmirli 3 otaqlı ev, Bakı, Xətai", "evler", 185000],
  ["Həyət evi, 6 sot torpaq sahəsi ilə", "evler", 240000],
  ["2 otaqlı mənzil, Nərimanov, yeni tikili", "menziller", 138000],
  ["4 otaqlı geniş mənzil, Yasamal", "menziller", 210000],
  ["Bağ evi, Mərdəkan, hovuzlu", "baglar", 95000],
  ["Bağ sahəsi, 10 sot, Şüvəlan", "baglar", 62000],
  ["Ofis sahəsi kirayə, 120 m², Port Baku", "ofisler", 2800],
  ["Ofis, 60 m², Səbail rayonu", "ofisler", 1500],
  ["Ticarət obyekti, 200 m², Gənclik", "obyektler", 4500],
  ["Restoran obyekti, tam avadanlıqlı", "obyektler", 320000],
  ["Mercedes-Benz E 200, 2019, ideal vəziyyət", "masinlar", 58500],
  ["Toyota Prius 2015, qənaətcil", "masinlar", 26400],
  ["Hyundai Elantra 2021, az yürüş", "masinlar", 34900],
  ["Yamaha MT-07 motosiklet, 2020", "motosikletler", 15800],
  ["Elektrik moped, yeni", "motosikletler", 1450],
  ["iPhone 15 Pro Max 256GB, zəmanətli", "telefonlar", 2350],
  ["Samsung Galaxy S24 Ultra, tam dəst", "telefonlar", 2100],
  ["Xiaomi Redmi Note 13 Pro", "telefonlar", 620],
  ["MacBook Air M2 13\", 512GB", "elektronika", 2450],
  ["Sony PlayStation 5 Slim + 2 pult", "elektronika", 1290],
  ["Samsung 55\" 4K Smart TV", "elektronika", 980],
  ["Künc divan, yeni, çatdırılma var", "meiset-esyalari", 850],
  ["Soyuducu Bosch, az işlənmiş", "meiset-esyalari", 620],
  ["Paltaryuyan maşın LG 8 kq", "meiset-esyalari", 540],
  ["Soyuducu Samsung Twin Cooling, 360L", "meiset-texnikasi", 890],
  ["Paltaryuyan maşın Bosch Seriyali 6", "meiset-texnikasi", 720],
  ["Kondisioner LG Artcool 12000 BTU", "meiset-texnikasi", 680],
  ["Blender Philips, 800W, yeni", "meiset-texnikasi", 145],
  ["Tozsoran Dyson V11 Absolute", "meiset-texnikasi", 540],
  ["Ütü Philips PerfectCare, buxarlı", "meiset-texnikasi", 210],
  ["Samsung 55\" 4K Smart TV, QLED", "meiset-texnikasi", 1290],
  ["Kişi dəri gödəkçə, orijinal", "geyim", 180],
  ["Qadın qış paltosu, M ölçü", "geyim", 130],
  ["Uşaq arabası 3 və 1, yeni", "usaq-alemi", 320],
  ["Uşaq çarpayısı və döşək", "usaq-alemi", 210],
  ["Alman ovçarkası balaları", "heyvanlar", 450],
  ["Britaniya pişik balaları, peyvəndli", "heyvanlar", 280],
  ["Kondisioner quraşdırılması və servis", "xidmetler", 60],
  ["Mənzil təmiri, açar təslim", "xidmetler", 1200],
  ["Satış meneceri vakansiyası, Bakı", "is-elanlari", 1100],
  ["Kuryer tələb olunur, sərbəst qrafik", "is-elanlari", 900],
  ["Ofis menecer, tam iş günü", "is-elanlari", 950],
];

const sellers = [
  "Elvin Məmmədov",
  "Aysel Quliyeva",
  "Rəşad Əliyev",
  "Nigar Hüseynova",
  "Kamran Sadıqov",
  "Günel Rzayeva",
  "Tural Abbasov",
];

function img(seed: string, i: number) {
  void seed;
  void i;
  return "/listing-placeholder.webp";
}

export const ads: Ad[] = seedTitles.map(([title, category, price], i) => {
  const id = String(1000 + i);
  const badge: Ad["badge"] = i % 7 === 0 ? "vip" : i % 5 === 0 ? "premium" : "none";
  const days = (i * 3) % 28;
  const date = new Date(2026, 6, 30 - days, 9 + (i % 10), (i * 7) % 60);
  return {
    id,
    title,
    description:
      "Məhsul/xidmət real vəziyyətdədir, şəkillərdə göründüyü kimidir. Ətraflı məlumat üçün zəng edə və ya WhatsApp vasitəsilə yaza bilərsiniz. Qiymətdə razılaşmaq mümkündür. Ciddi müştərilər nəzərə alınır.",
    price,
    negotiable: i % 3 === 0,
    category,
    city: cities[(i * 5) % 20]!,
    phone: `+994 5${i % 10} ${300 + i} ${10 + (i % 80)} ${20 + (i % 70)}`,
    whatsapp: `9945${i % 10}${300 + i}${10 + (i % 80)}${20 + (i % 70)}`,
    seller: sellers[i % sellers.length]!,
    sellerSince: `${2018 + (i % 7)}`,
    createdAt: date.toISOString(),
    views: 120 + i * 37,
    badge,
    featured: i % 4 === 0,
    images: [img(id, 1), img(id, 2), img(id, 3), img(id, 4)],
    status: i % 11 === 0 ? "pending" : "active",
  };
});

export const categoryName = (slug: string) =>
  categories.find((c) => c.slug === slug)?.name ?? slug;

export const formatPrice = (n: number) => {
  const value = Number(n) || 0;
  const hasFraction = Math.abs(value % 1) > 0.0001;
  const fixed = hasFraction ? value.toFixed(2) : Math.round(value).toString();
  const dotIndex = fixed.indexOf(".");
  const intPart = dotIndex === -1 ? fixed : fixed.slice(0, dotIndex);
  const decPart = dotIndex === -1 ? "" : fixed.slice(dotIndex + 1);
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return decPart ? `${formattedInt},${decPart} ₼` : `${formattedInt} ₼`;
};



export const timeAgo = (iso: string) => {
  const diff = Date.now() - new Date(iso).getTime();
  const d = Math.floor(diff / 86400000);
  if (d <= 0) return "Bu gün";
  if (d === 1) return "Dünən";
  if (d < 30) return `${d} gün əvvəl`;
  return new Date(iso).toLocaleDateString("az-AZ");
};
export type SubCategory = { slug: string; name: string; keywords: string[] };

export const subcategories: Record<string, SubCategory[]> = {
  evler: [
    { slug: "heyet-evi", name: "Həyət evi", keywords: ["həyət", "villa"] },
    { slug: "villa", name: "Villa", keywords: ["villa"] },
    { slug: "bag-evi", name: "Bağ evi", keywords: ["bağ"] },
    { slug: "kiraye-ev", name: "Kirayə ev", keywords: ["kirayə"] },
    { slug: "satilir-ev", name: "Satılır ev", keywords: ["satılır", "ev satılır"] },
    { slug: "kotec", name: "Kotec", keywords: ["kotec"] },
    { slug: "tecili-satilir", name: "Təcili satılır", keywords: ["təcili"] },
    { slug: "ipoteka", name: "İpoteka ilə", keywords: ["ipoteka"] },
    { slug: "gunluk-kiraye-ev", name: "Günlük kirayə ev", keywords: ["günlük", "sutkalıq"] },
    { slug: "deniz-kenari", name: "Dəniz kənarı ev", keywords: ["dəniz kənarı"] },
  ],
  menziller: [
    { slug: "yeni-tikili", name: "Yeni tikili", keywords: ["yeni tikili"] },
    { slug: "kohne-tikili", name: "Köhnə tikili", keywords: ["köhnə"] },
    { slug: "1-otaqli", name: "1 otaqlı", keywords: ["1 otaq"] },
    { slug: "2-otaqli", name: "2 otaqlı", keywords: ["2 otaq"] },
    { slug: "3-otaqli", name: "3 otaqlı", keywords: ["3 otaq"] },
    { slug: "kiraye", name: "Kirayə", keywords: ["kirayə"] },
    { slug: "4-otaqli", name: "4 otaqlı", keywords: ["4 otaq"] },
    { slug: "5-otaqli", name: "5 və daha çox otaqlı", keywords: ["5 otaq"] },
    { slug: "studiya", name: "Studiya", keywords: ["studiya"] },
    { slug: "temirli", name: "Təmirli mənzil", keywords: ["təmirli"] },
    { slug: "temirsiz", name: "Təmirsiz mənzil", keywords: ["təmirsiz"] },
    { slug: "cixarisli", name: "Çıxarışlı mənzil", keywords: ["çıxarış", "kupça"] },
    { slug: "gunluk-kiraye", name: "Günlük kirayə mənzil", keywords: ["günlük kirayə", "sutkalıq"] },
  ],
  baglar: [
    { slug: "novxani", name: "Novxanı", keywords: ["novxanı"] },
    { slug: "mardakan", name: "Mərdəkan", keywords: ["mərdəkan"] },
    { slug: "shuvelan", name: "Şüvəlan", keywords: ["şüvəlan"] },
    { slug: "bilgeh", name: "Bilgəh", keywords: ["bilgəh"] },
    { slug: "buzovna", name: "Buzovna", keywords: ["buzovna"] },
    { slug: "nardaran", name: "Nardaran", keywords: ["nardaran"] },
    { slug: "qobustan", name: "Qobustan", keywords: ["qobustan"] },
    { slug: "bag-kiraye", name: "Kirayə bağ evi", keywords: ["kirayə bağ"] },
    { slug: "hovuzlu-bag", name: "Hovuzlu bağ evi", keywords: ["hovuz"] },
  ],
  ofisler: [
    { slug: "kiraye-ofis", name: "Kirayə ofis", keywords: ["kirayə"] },
    { slug: "satilir", name: "Satılır", keywords: ["satılır"] },
    { slug: "kovorkinq", name: "Kovorkinq", keywords: ["kovorkinq"] },
    { slug: "biznes-merkez", name: "Biznes mərkəzdə ofis", keywords: ["biznes mərkəz"] },
    { slug: "temirli-ofis", name: "Təmirli ofis", keywords: ["təmirli ofis"] },
    { slug: "mebelli-ofis", name: "Mebelli ofis", keywords: ["mebelli ofis"] },
    { slug: "virtual-ofis", name: "Virtual ofis", keywords: ["virtual ofis"] },
  ],
  obyektler: [
    { slug: "magaza", name: "Mağaza", keywords: ["mağaza"] },
    { slug: "anbar", name: "Anbar", keywords: ["anbar"] },
    { slug: "restoran", name: "Restoran", keywords: ["restoran", "kafe"] },
    { slug: "ofis-binasi", name: "Ofis binası", keywords: ["ofis binası"] },
    { slug: "kafe", name: "Kafe", keywords: ["kafe"] },
    { slug: "gozellik-salonu", name: "Gözəllik salonu", keywords: ["gözəllik salonu", "salon"] },
    { slug: "yanacaqdoldurma", name: "Yanacaqdoldurma", keywords: ["yanacaq", "benzin"] },
    { slug: "istehsalat", name: "İstehsalat sahəsi", keywords: ["istehsalat", "sex"] },
    { slug: "avtoyuma", name: "Avtoyuma", keywords: ["avtoyuma"] },
  ],
  torpaq: [
    { slug: "sot-torpaq", name: "Sot torpaq", keywords: ["sot", "torpaq"] },
    { slug: "kend-teseffusu", name: "Kənd təsərrüfatı", keywords: ["kənd", "torpaq sahəsi"] },
    { slug: "tikinti-torpaq", name: "Tikinti torpağı", keywords: ["tikinti", "torpaq"] },
    { slug: "bag-torpaq", name: "Bağ torpağı", keywords: ["bağ torpağı"] },
    { slug: "ticaret-torpaq", name: "Ticarət torpağı", keywords: ["ticarət", "torpaq"] },
    { slug: "heyet-torpaq", name: "Həyətyanı torpaq", keywords: ["həyətyanı"] },
    { slug: "senaye-torpaq", name: "Sənaye torpağı", keywords: ["sənaye"] },
    { slug: "baglar-torpaq", name: "Bağ sahəsi", keywords: ["bağ sahəsi"] },
    { slug: "investisiya-torpaq", name: "İnvestisiya üçün torpaq", keywords: ["investisiya"] },
  ],
  otel: [
    { slug: "otel-satilir", name: "Otel satılır", keywords: ["otel satılır"] },
    { slug: "otel-kiraye", name: "Otel kirayə", keywords: ["otel kirayə"] },
    { slug: "hostel", name: "Hostel", keywords: ["hostel"] },
    { slug: "motelyer", name: "Motel", keywords: ["motel"] },
    { slug: "istirahet-merkezi", name: "İstirahət mərkəzi", keywords: ["istirahət mərkəzi"] },
    { slug: "apart-otel", name: "Apart otel", keywords: ["apart"] },
    { slug: "guest-house", name: "Qonaq evi", keywords: ["qonaq evi", "guest house"] },
    { slug: "bungalov", name: "Bunqalov", keywords: ["bunqalov"] },
    { slug: "otel-otaq", name: "Otel otağı", keywords: ["otel otağı"] },
  ],
  masinlar: [
    { slug: "mercedes", name: "Mercedes", keywords: ["mercedes"] },
    { slug: "bmw", name: "BMW", keywords: ["bmw"] },
    { slug: "toyota", name: "Toyota", keywords: ["toyota"] },
    { slug: "hyundai", name: "Hyundai", keywords: ["hyundai"] },
    { slug: "kia", name: "Kia", keywords: ["kia"] },
    { slug: "lada", name: "LADA", keywords: ["lada", "vaz"] },
    { slug: "ehtiyat-hisseleri", name: "Ehtiyat hissələri", keywords: ["ehtiyat", "disk", "təkər"] },
    { slug: "nissan", name: "Nissan", keywords: ["nissan"] },
    { slug: "chevrolet", name: "Chevrolet", keywords: ["chevrolet"] },
    { slug: "opel", name: "Opel", keywords: ["opel"] },
    { slug: "ford", name: "Ford", keywords: ["ford"] },
    { slug: "volkswagen", name: "Volkswagen", keywords: ["volkswagen", "vw"] },
    { slug: "audi", name: "Audi", keywords: ["audi"] },
    { slug: "honda", name: "Honda", keywords: ["honda"] },
    { slug: "renault", name: "Renault", keywords: ["renault"] },
    { slug: "gaz-uaz", name: "QAZ / UAZ", keywords: ["qaz", "uaz"] },
    { slug: "yuk-masinlari", name: "Yük maşınları", keywords: ["yük maşını", "kamaz"] },
    { slug: "avtobus", name: "Avtobus və mikroavtobus", keywords: ["avtobus", "mikroavtobus"] },
    { slug: "kend-teserrufati-texnika", name: "Kənd təsərrüfatı texnikası", keywords: ["traktor", "kombayn"] },
    { slug: "qosqu", name: "Qoşqu və treyler", keywords: ["qoşqu", "treyler"] },
    { slug: "kiraye-masin", name: "Kirayə maşın", keywords: ["kirayə maşın", "rent a car"] },
    { slug: "elektromobil", name: "Elektromobil", keywords: ["elektromobil", "tesla", "electric"] },
  ],
  motosikletler: [
    { slug: "moped", name: "Moped", keywords: ["moped"] },
    { slug: "kvadrosikl", name: "Kvadrosikl", keywords: ["kvadro"] },
    { slug: "velosiped", name: "Velosiped", keywords: ["velosiped"] },
    { slug: "motoskuter", name: "Motoskuter", keywords: ["motoskuter"] },
    { slug: "kross-motosiklet", name: "Kross motosiklet", keywords: ["kross", "enduro"] },
    { slug: "elektrovelosiped", name: "Elektrovelosiped", keywords: ["elektrovelosiped"] },
    { slug: "moto-ehtiyat", name: "Ehtiyat hissələri", keywords: ["ehtiyat", "zapçast"] },
    { slug: "moto-geyim", name: "Moto geyim və dəbilqə", keywords: ["dəbilqə", "moto geyim"] },
  ],
  "iki-tekerli-neqliyyat": [
    { slug: "skuter", name: "Skuter", keywords: ["skuter", "scooter"] },
    { slug: "motosiklet", name: "Motosiklet", keywords: ["motosiklet", "motorcycle"] },
    { slug: "moped", name: "Moped", keywords: ["moped"] },
    { slug: "elektrik-skuter", name: "Elektrik skuter", keywords: ["elektrik skuter", "elektrik scooter", "e-scooter"] },
    { slug: "elektrik-moped", name: "Elektrik moped", keywords: ["elektrik moped", "e-moped"] },
    { slug: "oxsar-neqliyyat", name: "Oxşar nəqliyyat vasitələri", keywords: ["iki təkərli", "oxşar nəqliyyat"] },
  ],
  telefonlar: [
    { slug: "iphone", name: "iPhone", keywords: ["iphone", "apple"] },
    { slug: "samsung", name: "Samsung", keywords: ["samsung"] },
    { slug: "xiaomi", name: "Xiaomi", keywords: ["xiaomi", "redmi"] },
    { slug: "aksesuar", name: "Aksesuarlar", keywords: ["qılıf", "adapter", "qulaqlıq"] },
    { slug: "huawei", name: "Huawei", keywords: ["huawei", "honor"] },
    { slug: "nokia", name: "Nokia", keywords: ["nokia"] },
    { slug: "realme-oppo", name: "Realme və Oppo", keywords: ["realme", "oppo"] },
    { slug: "tecno-infinix", name: "Tecno və Infinix", keywords: ["tecno", "infinix"] },
    { slug: "dugmeli-telefon", name: "Düyməli telefonlar", keywords: ["düyməli"] },
    { slug: "smart-saat", name: "Smart saatlar", keywords: ["smart saat", "apple watch"] },
    { slug: "qulaqliq", name: "Qulaqlıqlar", keywords: ["qulaqlıq", "airpods"] },
    { slug: "power-bank", name: "Power bank", keywords: ["power bank", "adapter"] },
    { slug: "telefon-ehtiyat", name: "Ehtiyat hissələri", keywords: ["ekran", "batareya"] },
  ],
  elektronika: [
    { slug: "noutbuk", name: "Noutbuklar", keywords: ["noutbuk", "macbook", "laptop"] },
    { slug: "kompyuter", name: "Kompüterlər", keywords: ["kompüter", "pc"] },
    { slug: "tv", name: "Televizorlar", keywords: ["televizor", "tv"] },
    { slug: "oyun-konsollari", name: "Oyun konsolları", keywords: ["playstation", "xbox", "konsol"] },
    { slug: "foto", name: "Foto və video", keywords: ["kamera", "foto"] },
    { slug: "soyuducu", name: "Soyuducu", keywords: ["soyuducu"] },
    { slug: "paltaryuyan-masin", name: "Paltaryuyan maşın", keywords: ["paltaryuyan"] },
    { slug: "qabyuyan-masin", name: "Qabyuyan maşın", keywords: ["qabyuyan"] },
    { slug: "soba-bisirme-paneli", name: "Sobalar və bişirmə panelləri", keywords: ["soba", "bişirmə paneli"] },
    { slug: "mikrodalgali-soba", name: "Mikrodalğalı soba", keywords: ["mikrodalğalı"] },
    { slug: "kondisioner", name: "Kondisioner", keywords: ["kondisioner"] },
    { slug: "tozsoran", name: "Tozsoran", keywords: ["tozsoran"] },
    { slug: "su-qizdiricisi", name: "Su qızdırıcisi", keywords: ["su qızdırıcı", "kombi"] },
    { slug: "aspirator", name: "Aspirator", keywords: ["aspirator"] },
    { slug: "dondurucu", name: "Dondurucu", keywords: ["dondurucu"] },
    { slug: "kicik-meiset-texnikasi", name: "Kiçik məişət texnikası", keywords: ["blender", "çaydan", "ütü"] },
  ],
  "meiset-esyalari": [
    { slug: "soyuducu", name: "Soyuducular", keywords: ["soyuducu"] },
    { slug: "paltaryuyan", name: "Paltaryuyanlar", keywords: ["paltaryuyan"] },
    { slug: "kondisioner", name: "Kondisionerlər", keywords: ["kondisioner"] },
    { slug: "qab-qacaq", name: "Qab-qacaq", keywords: ["qab", "qacaq", "boşqab"] },
    { slug: "xalca", name: "Xalça və palaz", keywords: ["xalça", "palaz"] },
    { slug: "perde", name: "Pərdə və tekstil", keywords: ["pərdə", "tekstil"] },
    { slug: "yataq-desti", name: "Yataq dəstləri", keywords: ["yataq dəsti", "yorğan"] },
    { slug: "isiqlandirma", name: "İşıqlandırma", keywords: ["çilçıraq", "lampa"] },
    { slug: "dekor", name: "Dekorativ əşyalar", keywords: ["dekor", "vaza"] },
    { slug: "temizlik-vasiteleri", name: "Təmizlik vasitələri", keywords: ["təmizlik"] },
  ],
  "meiset-texnikasi": [
    { slug: "metbex-texnikasi", name: "Mətbəx texnikası", keywords: ["qazan", "tava", "blender", "mikser", "mətbəx"] },
    { slug: "temizlik-texnikasi", name: "Təmizlik texnikası", keywords: ["tozsoran", "buxarlı", "təmizləyici", "təmizlik"] },
    { slug: "utuleme-texnikasi", name: "Ütüləmə texnikası", keywords: ["ütü", "buxar ütüsü", "ütüləmə"] },
    { slug: "soyuducular", name: "Soyuducular", keywords: ["soyuducu"] },
    { slug: "paltaryuyan-masinlar", name: "Paltaryuyan maşınlar", keywords: ["paltaryuyan"] },
    { slug: "televizor-multimedia", name: "Televizor və multimedia", keywords: ["televizor", "tv", "multimedia", "smart tv"] },
    { slug: "kondisionerler", name: "Kondisionerlər", keywords: ["kondisioner", "klimat"] },
    { slug: "diger-meiset-texnikasi", name: "Digər məişət texnikası", keywords: ["məişət", "texnika"] },
  ],
  mebel: [
    { slug: "divan", name: "Divan", keywords: ["divan", "künc divan"] },
    { slug: "kreslo", name: "Kreslo", keywords: ["kreslo"] },
    { slug: "masa", name: "Masa", keywords: ["masa"] },
    { slug: "oturacaq", name: "Oturacaq", keywords: ["oturacaq", "stul"] },
    { slug: "yataq", name: "Yataq", keywords: ["yataq", "çarpayı"] },
    { slug: "dolab", name: "Dolab", keywords: ["dolab", "şkaf"] },
    { slug: "komod", name: "Komod", keywords: ["komod"] },
    { slug: "kitab-skafi", name: "Kitab şkafı", keywords: ["kitab şkafı"] },
    { slug: "metbex-mebeli", name: "Mətbəx mebeli", keywords: ["mətbəx mebel"] },
    { slug: "ofis-mebeli", name: "Ofis mebeli", keywords: ["ofis mebel"] },
    { slug: "usaq-mebeli", name: "Uşaq mebeli", keywords: ["uşaq mebel"] },
    { slug: "guzgu", name: "Güzgü", keywords: ["güzgü"] },
    { slug: "diger-mebel", name: "Digər", keywords: ["mebel"] },
  ],
  geyim: [
    { slug: "kisi", name: "Kişi geyimləri", keywords: ["kişi"] },
    { slug: "qadin", name: "Qadın geyimləri", keywords: ["qadın"] },
    { slug: "ayaqqabi", name: "Ayaqqabılar", keywords: ["ayaqqabı", "krossovka"] },
    { slug: "saat-aksesuar", name: "Saat və aksesuar", keywords: ["saat", "çanta"] },
    { slug: "kisi-geyimi", name: "Kişi geyimi", keywords: ["kişi"] },
    { slug: "qadin-geyimi", name: "Qadın geyimi", keywords: ["qadın"] },
    { slug: "usaq-geyimi", name: "Uşaq geyimi", keywords: ["uşaq geyim"] },
    { slug: "ust-geyim", name: "Üst geyim", keywords: ["gödəkçə", "palto", "kurtka"] },
    { slug: "koynek", name: "Köynək və bluz", keywords: ["köynək", "bluz"] },
    { slug: "salvar-cins", name: "Şalvar və cins", keywords: ["şalvar", "cins"] },
    { slug: "don-yubka", name: "Don və yubka", keywords: ["don", "yubka"] },
    { slug: "idman-geyimi", name: "İdman geyimi", keywords: ["idman geyim", "futbolka"] },
    { slug: "is-geyimi", name: "İş geyimi", keywords: ["iş geyimi", "kombinezon"] },
    { slug: "nisan-toy", name: "Nişan və toy paltarları", keywords: ["gəlinlik", "nişan"] },
  ],
  "usaq-alemi": [
    { slug: "usaq-geyimi", name: "Uşaq geyimləri", keywords: ["uşaq geyim"] },
    { slug: "arabalar", name: "Uşaq arabaları", keywords: ["araba"] },
    { slug: "oyuncaqlar", name: "Oyuncaqlar", keywords: ["oyuncaq"] },
    { slug: "usaq-arabasi", name: "Uşaq arabaları", keywords: ["araba", "kolyaska"] },
    { slug: "usaq-cargahi", name: "Uşaq çarpayıları", keywords: ["çarpayı", "beşik"] },
    { slug: "avto-oturacaq", name: "Avtomobil oturacaqları", keywords: ["avtokreslo", "oturacaq"] },
    { slug: "oyuncaq", name: "Oyuncaqlar", keywords: ["oyuncaq"] },
    { slug: "usaq-geyim", name: "Uşaq geyimləri", keywords: ["uşaq geyim"] },
    { slug: "mektebli", name: "Məktəbli ləvazimatı", keywords: ["çanta", "məktəbli"] },
    { slug: "usaq-mebeli", name: "Uşaq mebeli", keywords: ["uşaq mebel"] },
    { slug: "qidalanma", name: "Qidalanma ləvazimatı", keywords: ["butulka", "sterilizator"] },
  ],
  heyvanlar: [
    { slug: "itler", name: "İtlər", keywords: ["it", "küçük"] },
    { slug: "pisikler", name: "Pişiklər", keywords: ["pişik"] },
    { slug: "quslar", name: "Quşlar", keywords: ["quş", "tutuquşu"] },
    { slug: "akvarium", name: "Akvarium", keywords: ["akvarium", "balıq"] },
    { slug: "it", name: "İtlər", keywords: ["it", "köpək"] },
    { slug: "pisik", name: "Pişiklər", keywords: ["pişik"] },
    { slug: "qus", name: "Quşlar", keywords: ["quş", "tutuquşu"] },
    { slug: "ev-heyvani-yemi", name: "Yem və aksesuarlar", keywords: ["yem", "aksesuar"] },
    { slug: "mal-qara", name: "Mal-qara", keywords: ["inək", "dana"] },
    { slug: "qoyun-keci", name: "Qoyun və keçi", keywords: ["qoyun", "keçi"] },
    { slug: "toyuq-ferma", name: "Ev quşları", keywords: ["toyuq", "ördək"] },
  ],
  xidmetler: [
    { slug: "temir", name: "Təmir və tikinti", keywords: ["təmir", "tikinti"] },
    { slug: "nequliyyat", name: "Nəqliyyat", keywords: ["daşınma", "yük"] },
    { slug: "tedris", name: "Tədris", keywords: ["dərs", "kurs", "repetitor"] },
    { slug: "gozellik", name: "Gözəllik", keywords: ["gözəllik", "saç"] },
    { slug: "temir-tikinti", name: "Təmir və tikinti", keywords: ["təmir", "usta"] },
    { slug: "neqliyyat-xidmeti", name: "Yükdaşıma və nəqliyyat", keywords: ["yükdaşıma", "daşınma"] },
    { slug: "temizlik-xidmeti", name: "Təmizlik xidməti", keywords: ["təmizlik"] },
    { slug: "tercume", name: "Tərcümə xidməti", keywords: ["tərcümə"] },
    { slug: "repetitor", name: "Repetitor və kurslar", keywords: ["repetitor", "kurs"] },
    { slug: "hüquq", name: "Hüquq və mühasibatlıq", keywords: ["hüquq", "mühasib"] },
    { slug: "foto-video", name: "Foto və video çəkiliş", keywords: ["foto", "video çəkiliş"] },
    { slug: "tedbir", name: "Tədbir təşkili", keywords: ["tədbir", "toy"] },
    { slug: "kompyuter-xidmeti", name: "Kompüter xidməti", keywords: ["kompüter təmiri"] },
    { slug: "sehiyye-xidmeti", name: "Sağlamlıq xidmətləri", keywords: ["tibb", "masaj"] },
  ],
  "idman-eylence": [
    { slug: "doyus-idmanlari", name: "Döyüş idmanları", keywords: ["döyüş idman", "boks", "kikboks", "mma", "karate"] },
    { slug: "boks-elcekleri", name: "Boks əlcəkləri", keywords: ["boks əlcək", "əlcək"] },
    { slug: "usaq-boks-elcekleri", name: "Uşaq boks əlcəkləri", keywords: ["uşaq boks əlcək", "uşaq əlcək"] },
    { slug: "boks-qoruyuculari", name: "Boks qoruyucuları", keywords: ["qoruyucu", "kaska", "dişlik", "bandaj"] },
    { slug: "boks-kiseleri", name: "Boks kisələri", keywords: ["boks kisəsi", "kanki", "qum kisəsi", "armud"] },
    { slug: "boks-geyimleri", name: "Boks geyimləri", keywords: ["boks geyim", "şort", "mayka"] },
    { slug: "boks-ayaqqabilari", name: "Boks ayaqqabıları", keywords: ["boks ayaqqabı", "ring ayaqqabısı"] },
    { slug: "kikboksinq-avadanliqlari", name: "Kikboksinq avadanlıqları", keywords: ["kikboks", "kickboxing", "pəncə", "şitok"] },
    { slug: "diger-boks-avadanliqlari", name: "Digər boks avadanlıqları", keywords: ["boks avadanlıq", "döyüş avadanlıq"] },
  ],
  "is-elanlari": [
    { slug: "ofis-isleri", name: "Ofis işləri", keywords: ["ofis", "menecer", "katibə", "inzibati"] },
    { slug: "satis", name: "Satış", keywords: ["satıcı", "satış"] },
    { slug: "market-kassir", name: "Market və Kassir", keywords: ["market", "kassir"] },
    { slug: "restoran-kafe", name: "Restoran və Kafe", keywords: ["restoran", "kafe"] },
    { slug: "surucu", name: "Sürücü", keywords: ["sürücü"] },
    { slug: "taksi", name: "Taksi", keywords: ["taksi"] },
    { slug: "kuryer", name: "Kuryer", keywords: ["kuryer", "çatdırılma"] },
    { slug: "anbar", name: "Anbar", keywords: ["anbar"] },
    { slug: "tikinti", name: "Tikinti", keywords: ["tikinti", "fəhlə", "usta"] },
    { slug: "muhafize", name: "Mühafizə", keywords: ["mühafizə", "keşikçi"] },
    { slug: "temizlik", name: "Təmizlik", keywords: ["təmizlik", "xadimə"] },
    { slug: "daye", name: "Dayə", keywords: ["dayə"] },
    { slug: "yasli-baxicisi", name: "Yaşlı baxıcısı", keywords: ["yaşlı baxıcı"] },
    { slug: "usaq-baxicisi", name: "Uşaq baxıcısı", keywords: ["uşaq baxıcı"] },
    { slug: "aspaz", name: "Aşpaz", keywords: ["aşpaz"] },
    { slug: "ofisiant", name: "Ofisiant", keywords: ["ofisiant"] },
    { slug: "barista", name: "Barista", keywords: ["barista"] },
    { slug: "berber", name: "Bərbər", keywords: ["bərbər"] },
    { slug: "kosmetoloq-is", name: "Kosmetoloq", keywords: ["kosmetoloq"] },
    { slug: "masaj-xidmetleri", name: "Masaj xidmətləri", keywords: ["masaj", "massaj"] },
    { slug: "otel-vakansiyalari", name: "Otel Vakansiyaları", keywords: ["otel", "hotel", "resepsion", "bellboy"] },
    { slug: "gozellik-salonu-vakansiyalari", name: "Gözəllik Salonu Vakansiyaları", keywords: ["gözəllik salonu", "bərbər", "manikür", "vizajist"] },
    { slug: "it-proqramlasdirma", name: "İT və Proqramlaşdırma", keywords: ["proqram", "developer", "it "] },
    { slug: "dizayn", name: "Dizayn", keywords: ["dizayn", "designer"] },
    { slug: "muhasibat", name: "Mühasibat", keywords: ["mühasib"] },
    { slug: "tehsil", name: "Təhsil", keywords: ["müəllim", "repetitor"] },
    { slug: "tibb", name: "Tibb", keywords: ["həkim", "tibb bacısı"] },
    { slug: "diger-is", name: "Digər", keywords: ["digər"] },
  ],
  masaj: [
    { slug: "spa", name: "Spa", keywords: ["spa"] },
    { slug: "sauna", name: "Sauna", keywords: ["sauna"] },
    { slug: "hamam", name: "Hamam", keywords: ["hamam"] },
    { slug: "cakuzi", name: "Cakuzi", keywords: ["cakuzi", "jacuzzi"] },
    { slug: "buxar-otagi", name: "Buxar otağı", keywords: ["buxar"] },
    { slug: "relaks-merkezleri", name: "Relaks mərkəzləri", keywords: ["relaks"] },
    { slug: "klassik-masaj", name: "Klassik masaj", keywords: ["klassik masaj"] },
    { slug: "terapevtik-masaj", name: "Terapevtik masaj", keywords: ["terapevtik"] },
    { slug: "idman-masaji", name: "İdman masajı", keywords: ["idman masaj"] },
    { slug: "aromaterapiya", name: "Aromaterapiya", keywords: ["aroma"] },
    { slug: "ayaq-masaji", name: "Ayaq masajı", keywords: ["ayaq masaj"] },
    { slug: "masaj-salonlari", name: "Masaj salonları", keywords: ["masaj salon"] },
    { slug: "eve-gelmekle-masaj", name: "Evə gəlməklə masaj", keywords: ["evə gəlmə"] },
    { slug: "wellness", name: "Wellness xidmətləri", keywords: ["wellness"] },
  ],
  kosmetoloq: [
    { slug: "uz-baximi", name: "Üz baxımı", keywords: ["üz baxım"] },
    { slug: "deri-temizlenmesi", name: "Dəri təmizlənməsi", keywords: ["dəri təmizlən"] },
    { slug: "peeling", name: "Peeling", keywords: ["peeling"] },
    { slug: "mezoterapiya", name: "Mezoterapiya", keywords: ["mezoterapiya"] },
    { slug: "botoks", name: "Botoks", keywords: ["botoks"] },
    { slug: "dolgu-fillerler", name: "Dolğu (Fillerlər)", keywords: ["dolğu", "filler"] },
    { slug: "lazer-epilyasiya", name: "Lazer epilyasiya", keywords: ["lazer", "epilyasiya"] },
    { slug: "qas-ve-kiprik", name: "Qaş və Kiprik", keywords: ["qaş", "kiprik"] },
    { slug: "makiyaj-vizaj", name: "Makiyaj (Vizaj)", keywords: ["makiyaj", "vizaj"] },
    { slug: "gozellik-prosedurlari", name: "Gözəllik prosedurları", keywords: ["gözəllik"] },
    { slug: "diger-kosmetoloji", name: "Digər kosmetoloji xidmətlər", keywords: ["kosmetoloq"] },
  ],
  kosmetika: [
    { slug: "uz-baximi-mehsullari", name: "Üz baxımı məhsulları", keywords: ["krem", "serum", "üz baxım"] },
    { slug: "makiyaj-mehsullari", name: "Makiyaj məhsulları", keywords: ["makiyaj", "kirşan", "pomada"] },
    { slug: "etir-parfum", name: "Ətir və parfüm", keywords: ["ətir", "parfüm", "parfum"] },
    { slug: "sac-baximi", name: "Saç baxımı", keywords: ["şampun", "saç"] },
    { slug: "beden-baximi", name: "Bədən baxımı", keywords: ["bədən", "losyon", "duş geli"] },
    { slug: "dirnaq-manikur", name: "Dırnaq və manikür", keywords: ["dırnaq", "lak", "manikür"] },
    { slug: "kisiler-ucun-kosmetika", name: "Kişilər üçün", keywords: ["kişi", "üz qırxma"] },
    { slug: "dest-hediyye", name: "Dəst və hədiyyə", keywords: ["dəst", "hədiyyə"] },
    { slug: "professional-avadanliq", name: "Professional avadanlıq", keywords: ["avadanlıq", "salon"] },
    { slug: "diger-kosmetika", name: "Digər kosmetika", keywords: ["kosmetika"] },
  ],
  saatlar: [
    { slug: "qol-saatlari", name: "Qol saatları", keywords: ["qol saat", "saat"] },
    { slug: "smart-saatlar", name: "Smart saatlar", keywords: ["smart saat", "smartwatch", "apple watch"] },
    { slug: "divar-saatlari", name: "Divar saatları", keywords: ["divar saat"] },
    { slug: "masa-saatlari", name: "Masaüstü saatlar", keywords: ["masa saat", "masaüstü saat"] },
    { slug: "usaq-saatlari", name: "Uşaq saatları", keywords: ["uşaq saat"] },
    { slug: "qadin-saatlari", name: "Qadın saatları", keywords: ["qadın saat"] },
    { slug: "kisi-saatlari", name: "Kişi saatları", keywords: ["kişi saat"] },
    { slug: "zeng-saatlari", name: "Zəngli saatlar", keywords: ["zəngli saat", "budilnik"] },
    { slug: "antik-saatlar", name: "Antik və kolleksiya saatları", keywords: ["antik saat", "kolleksiya"] },
    { slug: "saat-aksesuarlari", name: "Saat aksesuarları və qayışlar", keywords: ["qayış", "saat qayış"] },
    { slug: "diger-saatlar", name: "Digər saatlar", keywords: ["saat"] },
  ],
  guzguler: [
    { slug: "divar-guzgusu", name: "Divar güzgüsü", keywords: ["divar güzgü"] },
    { slug: "isiqli-guzgu", name: "İşıqlı (LED) güzgü", keywords: ["led güzgü", "işıqlı güzgü"] },
    { slug: "hamam-guzgusu", name: "Hamam güzgüsü", keywords: ["hamam güzgü"] },
    { slug: "tualet-masasi-guzgusu", name: "Tualet masası güzgüsü", keywords: ["tualet masa güzgü", "trilyaj"] },
    { slug: "boy-guzgusu", name: "Boy güzgüsü", keywords: ["boy güzgü"] },
    { slug: "dekorativ-guzgu", name: "Dekorativ güzgü", keywords: ["dekor güzgü"] },
    { slug: "makiyaj-guzgusu", name: "Makiyaj güzgüsü", keywords: ["makiyaj güzgü"] },
    { slug: "diger-guzguler", name: "Digər güzgülər", keywords: ["güzgü"] },
  ],
  "dus-kabinleri": [
    { slug: "sadə-dus-kabini", name: "Sadə duş kabini", keywords: ["duş kabin"] },
    { slug: "hidromasajli-kabin", name: "Hidromasajlı kabin", keywords: ["hidromasaj"] },
    { slug: "kunc-dus-kabini", name: "Künc duş kabini", keywords: ["künc duş"] },
    { slug: "dus-tekneleri", name: "Duş tekneleri (poddon)", keywords: ["poddon", "duş teknesi"] },
    { slug: "dus-qapilari", name: "Duş qapıları və arakəsmələr", keywords: ["duş qapı", "arakəsmə"] },
    { slug: "vanna-otagi-avadanligi", name: "Vanna otağı avadanlığı", keywords: ["vanna", "smesitel"] },
    { slug: "dus-ehtiyat-hisseleri", name: "Ehtiyat hissələri", keywords: ["ehtiyat hissə", "duş"] },
    { slug: "diger-dus-kabinleri", name: "Digər duş kabinləri", keywords: ["duş kabin"] },
  ],

  reklam: [
    { slug: "biznes-reklami", name: "Biznes reklamı", keywords: ["biznes"] },
    { slug: "magaza-reklami", name: "Mağaza reklamı", keywords: ["mağaza"] },
    { slug: "xidmet-reklami", name: "Xidmət reklamı", keywords: ["xidmət"] },
    { slug: "kampaniya", name: "Kampaniya və endirim", keywords: ["kampaniya", "endirim"] },
    { slug: "banner", name: "Banner reklamı", keywords: ["banner"] },
    { slug: "sosial-media", name: "Sosial media reklamı", keywords: ["instagram", "sosial"] },
    { slug: "seo-xidmeti", name: "SEO və sayt", keywords: ["seo", "sayt"] },
  ],
  ayaqqabi: [
    { slug: "kisi-ayaqqabi", name: "Kişi ayaqqabıları", keywords: ["kişi ayaqqabı"] },
    { slug: "qadin-ayaqqabi", name: "Qadın ayaqqabıları", keywords: ["qadın ayaqqabı"] },
    { slug: "usaq-ayaqqabi", name: "Uşaq ayaqqabıları", keywords: ["uşaq ayaqqabı"] },
    { slug: "krossovka", name: "Krossovkalar", keywords: ["krossovka", "sneaker"] },
    { slug: "cekme", name: "Çəkmələr", keywords: ["çəkmə", "bot"] },
    { slug: "terlik", name: "Terlik və sandal", keywords: ["terlik", "sandal"] },
  ],
  aksesuar: [
    { slug: "canta", name: "Çantalar", keywords: ["çanta"] },
    { slug: "saat", name: "Saatlar", keywords: ["saat"] },
    { slug: "eynek", name: "Eynəklər", keywords: ["eynək"] },
    { slug: "kemer", name: "Kəmərlər", keywords: ["kəmər"] },
    { slug: "papaq", name: "Papaq və şərflər", keywords: ["papaq", "şərf"] },
    { slug: "zerkli-aksesuar", name: "Bijuteriya", keywords: ["bijuteriya"] },
    { slug: "qadin-cantasi", name: "Qadın çantaları", keywords: ["qadın çanta"] },
    { slug: "kisi-cantasi", name: "Kişi çantaları", keywords: ["kişi çanta"] },
  ],
  "qizil-zinet": [
    { slug: "uzuk", name: "Üzüklər", keywords: ["üzük"] },
    { slug: "sirqa", name: "Sırğalar", keywords: ["sırğa"] },
    { slug: "boyunbagi", name: "Boyunbağılar", keywords: ["boyunbağı", "zəncir"] },
    { slug: "qolbaq", name: "Qolbaqlar", keywords: ["qolbaq", "bilərzik"] },
    { slug: "dest", name: "Zinət dəstləri", keywords: ["dəst", "zinət"] },
    { slug: "qizil-desti", name: "Qızıl dəstlər", keywords: ["qızıl dəst"] },
    { slug: "gumus", name: "Gümüş məmulatlar", keywords: ["gümüş"] },
    { slug: "brilyant", name: "Brilyant zinətlər", keywords: ["brilyant", "almaz"] },
    { slug: "nisan-uzuyu", name: "Nişan üzükləri", keywords: ["nişan üzük"] },
    { slug: "qizil-sikke", name: "Qızıl sikkələr", keywords: ["sikkə"] },
  ],
  "kompyuter-texnika": [
    { slug: "noutbuklar", name: "Noutbuklar", keywords: ["noutbuk", "laptop", "macbook"] },
    { slug: "stolustu-kompyuter", name: "Stolüstü kompüterlər", keywords: ["kompüter", "pc", "sistem bloku"] },
    { slug: "planset", name: "Planşetlər", keywords: ["planşet", "ipad", "tablet"] },
    { slug: "monitor", name: "Monitorlar", keywords: ["monitor", "ekran"] },
    { slug: "komplektedici", name: "Komplektedicilər", keywords: ["videokart", "prosessor", "ram", "ssd"] },
    { slug: "printer-skaner", name: "Printer və skanerlər", keywords: ["printer", "skaner", "mfu"] },
    { slug: "sebeke-avadanligi", name: "Şəbəkə avadanlığı", keywords: ["router", "modem", "switch"] },
    { slug: "kompyuter-aksesuar", name: "Aksesuarlar", keywords: ["klaviatura", "siçan", "çanta"] },
    { slug: "oyun-avadanligi", name: "Oyun avadanlığı", keywords: ["gaming", "konsol", "cüyür"] },
    { slug: "proqram-temini", name: "Proqram təminatı", keywords: ["proqram", "lisenziya", "software"] },
  ],
  "bag-bagciliq": [
    { slug: "toxum-tinq", name: "Toxum və tinglər", keywords: ["toxum", "ting", "əkin"] },
    { slug: "bitki-gul", name: "Bitki və güllər", keywords: ["gül", "bitki", "dibçək"] },
    { slug: "gubre-derman", name: "Gübrə və dərmanlar", keywords: ["gübrə", "dərman", "pestisid"] },
    { slug: "bag-alatleri", name: "Bağ alətləri", keywords: ["bel", "dırmıq", "budama"] },
    { slug: "suvarma-sistemleri", name: "Suvarma sistemləri", keywords: ["suvarma", "damcı", "şlanq"] },
    { slug: "istixana", name: "İstixana və örtüklər", keywords: ["istixana", "örtük", "plyonka"] },
    { slug: "bag-mebeli", name: "Bağ mebeli", keywords: ["bağ mebel", "mangal", "çətir"] },
    { slug: "ot-bicen", name: "Ot biçən və motobloklar", keywords: ["ot biçən", "motoblok", "kultivator"] },
  ],
  "tikinti-temir": [
    { slug: "tikinti-materiallari", name: "Tikinti materialları", keywords: ["sement", "kərpic", "beton"] },
    { slug: "sanitar-texnika", name: "Santexnika", keywords: ["santexnika", "unitaz", "kran"] },
    { slug: "elektrik-mallari", name: "Elektrik malları", keywords: ["kabel", "rozetka", "avtomat"] },
    { slug: "boya-lak", name: "Boya və laklar", keywords: ["boya", "lak", "şpaklyovka"] },
    { slug: "qapi-pencere", name: "Qapı və pəncərələr", keywords: ["qapı", "pəncərə", "plastik"] },
    { slug: "dosemə-kafel", name: "Döşəmə və kafel", keywords: ["kafel", "laminat", "parket"] },
    { slug: "alet-avadanliq", name: "Alət və avadanlıq", keywords: ["perforator", "drel", "bolqarka"] },
    { slug: "temir-xidmeti", name: "Təmir xidmətləri", keywords: ["təmir", "usta", "açar təslim"] },
  ],
  "sexsi-esyalar": [
    { slug: "canta-cuzdan", name: "Çanta və pulqabı", keywords: ["çanta", "pulqabı"] },
    { slug: "sexsi-baxim", name: "Şəxsi baxım", keywords: ["baxım", "gigiyena"] },
    { slug: "eynek-saat", name: "Eynək və saatlar", keywords: ["eynək", "saat"] },
    { slug: "cemodan", name: "Çamadan və səyahət", keywords: ["çamadan", "səyahət"] },
    { slug: "tibbi-mallar", name: "Tibbi mallar", keywords: ["tibbi", "tonometr", "ortopedik"] },
    { slug: "etir", name: "Ətirlər", keywords: ["ətir", "parfum"] },
    { slug: "sac-baxim", name: "Saç baxımı", keywords: ["saç", "fen"] },
    { slug: "tibbi-vasite", name: "Tibbi vasitələr", keywords: ["tibbi", "tonometr"] },
    { slug: "hediyye", name: "Hədiyyələr", keywords: ["hədiyyə"] },
  ],
  "kitab-tehsil": [
    { slug: "bedii-edebiyyat", name: "Bədii ədəbiyyat", keywords: ["roman", "kitab", "bədii"] },
    { slug: "dersliker", name: "Dərsliklər", keywords: ["dərslik", "abituriyent", "sinif"] },
    { slug: "usaq-kitablari", name: "Uşaq kitabları", keywords: ["uşaq kitab", "nağıl"] },
    { slug: "xarici-dil", name: "Xarici dil vəsaitləri", keywords: ["ingilis dili", "lüğət"] },
    { slug: "kurs-repetitor", name: "Kurs və repetitor", keywords: ["kurs", "repetitor", "hazırlıq"] },
    { slug: "qirtasiyye", name: "Qırtasiyyə", keywords: ["dəftər", "qələm", "qırtasiyyə"] },
    { slug: "dil-kurslari", name: "Dil öyrənmə vəsaitləri", keywords: ["ingilis", "dil"] },
    { slug: "kanselyariya", name: "Dəftərxana ləvazimatı", keywords: ["dəftər", "qələm"] },
  ],
  "hobbi-kolleksiya": [
    { slug: "musiqi-aletleri", name: "Musiqi alətləri", keywords: ["gitara", "piano", "musiqi"] },
    { slug: "antikvariat", name: "Antikvariat", keywords: ["antik", "qədim"] },
    { slug: "numizmatika", name: "Numizmatika və filateliya", keywords: ["sikkə", "marka", "pul"] },
    { slug: "elisi", name: "Əl işləri", keywords: ["əl işi", "handmade", "toxuma"] },
    { slug: "rəsm-sənət", name: "Rəsm və sənət", keywords: ["rəsm", "tablo", "sənət"] },
    { slug: "ovculuq-baliqciliq", name: "Ovçuluq və balıqçılıq", keywords: ["ov", "balıq", "tilov"] },
    { slug: "settl-oyunlar", name: "Stolüstü oyunlar", keywords: ["şahmat", "nərd", "puzzle"] },
    { slug: "ovculuq", name: "Ovçuluq və balıqçılıq", keywords: ["ov", "balıqçılıq"] },
    { slug: "antikvar", name: "Antikvar əşyalar", keywords: ["antikvar"] },
    { slug: "sikke-pul", name: "Sikkə və pullar", keywords: ["sikkə", "banknot"] },
  ],
  pulsuz: [
    { slug: "pulsuz-verilir", name: "Pulsuz verilir", keywords: ["pulsuz", "hədiyyə"] },
    { slug: "deyisdirilir", name: "Dəyişdirilir (barter)", keywords: ["dəyiş", "barter"] },
    { slug: "itmis-tapilmis", name: "İtmiş və tapılmış", keywords: ["itib", "tapılıb"] },
    { slug: "konullu-komek", name: "Könüllü kömək", keywords: ["kömək", "xeyriyyə"] },
    { slug: "pulsuz-mebel", name: "Pulsuz mebel", keywords: ["mebel"] },
    { slug: "pulsuz-geyim", name: "Pulsuz geyim", keywords: ["geyim"] },
    { slug: "pulsuz-texnika", name: "Pulsuz texnika", keywords: ["texnika"] },
    { slug: "pulsuz-heyvan", name: "Pulsuz heyvan", keywords: ["heyvan"] },
  ],
  kurslar: [
    { slug: "ingilis-dili", name: "İngilis dili kursu", keywords: ["ingilis dili", "english"] },
    { slug: "rus-dili", name: "Rus dili kursu", keywords: ["rus dili"] },
    { slug: "alman-dili", name: "Alman dili kursu", keywords: ["alman dili"] },
    { slug: "ielts-hazirliq", name: "IELTS hazırlığı", keywords: ["ielts", "toefl"] },
    { slug: "kompyuter-kursu", name: "Kompüter kursu", keywords: ["kompüter", "ofis proqramları"] },
    { slug: "dizayn-kursu", name: "Dizayn kursu", keywords: ["dizayn", "qrafik dizayn"] },
    { slug: "riyaziyyat-hazirliq", name: "Riyaziyyat hazırlığı", keywords: ["riyaziyyat", "abituriyent"] },
    { slug: "proqramlasdirma", name: "Proqramlaşdırma kursu", keywords: ["proqramlaşdırma", "kod"] },
    { slug: "muhasibat-kursu", name: "Mühasibat kursu", keywords: ["mühasibat", "1c"] },
  ],
  sirniyyatlar: [
    { slug: "tortlar", name: "Tortlar", keywords: ["tort", "ad günü tortu"] },
    { slug: "paxlava", name: "Paxlava", keywords: ["paxlava"] },
    { slug: "sekerbura", name: "Şəkərbura", keywords: ["şəkərbura", "novruz"] },
    { slug: "qogal", name: "Qoğal", keywords: ["qoğal"] },
    { slug: "pecenye", name: "Peçenye və peçenyələr", keywords: ["peçenye", "kuka"] },
    { slug: "sirniyyat-sifarisi", name: "Şirniyyat sifarişi", keywords: ["sifariş", "toy şirniyyatı"] },
  ],
};

/** Hər kateqoriyanın sonunda "Digər" bölməsi olsun. */
for (const [slug, list] of Object.entries(subcategories)) {
  if (!list.length) continue;
  if (list.some((s) => s.name.trim().toLowerCase().startsWith("digər"))) continue;
  list.push({ slug: `${slug}-diger`, name: "Digər", keywords: ["digər"] });
}

export const subcategoriesOf = (slug: string): SubCategory[] => subcategories[slug] ?? [];
